import React, { Component } from 'react';
import { Guardian } from '@xaamin/guardian';
import { Dropdown, ButtonGroup } from 'react-bootstrap';

import { Http } from '../../../../support';
import Loading from '../../../../facturotopia/loading/Loading';
import ClientesBulkDestroyModal from './ClientesBulkDestroyModal';

class ClientesItemActions extends Component {
  state = {};

  submit = async (reason = {}) => {
    this.setState({ busy: true });

    const { status, message } = reason;

    try {
      let response = {};
      const { selectedRowKeys } = this.props;

      if (selectedRowKeys.length > 1) {
        const params = {
          cliente_ids: selectedRowKeys,
          status,
          comentario: message ?? 'Solicitud admin',
        };
        response = await Http.patch(`api/clientes/status`, params);
      } else {
        const id = selectedRowKeys[0];
        response = await Http.patch(`api/clientes/${id}/status`, {
          status,
          comentario: message || 'Solicitud admin',
        });
      }

      this.setState({ busy: false });

      this.props.highlight(response.data);

      window.ToastManager.show({
        variant: 'success',
        title: 'Cambio de status',
        message: 'Actualización de status exitoso',
      });
    } catch (error) {
      const _error = error.data || error;

      this.setState({ busy: false });

      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: _error.message || 'Error recuperando información del cliente',
      });
    }
  };

  handleActive = () => {
    this.submit({
      status: 1,
      message: 'Solicitud admin',
    });
  };

  dueDate = () => {
    this.submit({
      status: -2,
      message: 'Falta de pago',
    });
  };

  handleSuspend = () => {
    this.submit({
      status: -1,
      message: 'Solicitud admin',
    });
  };

  handleDestroy = () => this.setState({ deleting: true });
  handleDestroyClose = () => this.setState({ deleting: false });

  isActive = () => {
    const { selectedRows } = this.props;

    const active = selectedRows.filter((item) => {
      return item.status === 1 || item.status === 2;
    });

    const suspended = selectedRows.filter((item) => {
      return item.status === -1 || item.status === -2;
    });

    let isActive = undefined;

    if (active.length > 0 && suspended.length === 0) {
      isActive = true;
    } else if (active.length === 0 && suspended.length > 0) {
      isActive = false;
    }

    return isActive;
  };

  render() {
    if (this.state.busy) {
      return <Loading />;
    }

    if (this.state.deleting) {
      return (
        <ClientesBulkDestroyModal
          show={this.state.deleting}
          onClose={this.handleDestroyClose}
          selectedRows={this.props.selectedRows}
        />
      );
    }

    let isActive = this.isActive();

    return (
      <Dropdown
        as={ButtonGroup}
        alignRight={false}
      >
        <Dropdown.Toggle
          split
          variant="secondary"
          id="dropdown-split-basic"
        >
          Acciones{' '}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {Guardian.allows('cliente.reenviar.invitacion') && (
            <Dropdown.Item as="div">Reenviar invitación</Dropdown.Item>
          )}

          {isActive === true && (
            <>
              {Guardian.allows('cliente.suspender') && (
                <Dropdown.Item
                  as="div"
                  onClick={this.handleSuspend}
                >
                  Suspender
                </Dropdown.Item>
              )}

              {Guardian.allows('cliente.suspender') && (
                <Dropdown.Item
                  as="div"
                  onClick={this.dueDate}
                >
                  Falta de pago
                </Dropdown.Item>
              )}
            </>
          )}

          {isActive === false && (
            <>
              {Guardian.allows('cliente.activar') && (
                <Dropdown.Item
                  as="div"
                  onClick={this.handleActive}
                >
                  Activar
                </Dropdown.Item>
              )}
            </>
          )}

          <>
            {Guardian.allows('cliente.eliminar') && (
              <Dropdown.Item
                as="div"
                onClick={this.handleDestroy}
              >
                Eliminar
              </Dropdown.Item>
            )}
          </>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default ClientesItemActions;
